export class NewCertificate {
    id: any = null;
    name: String = '';
    group: String = '';
}